import React from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';
import _ from 'lodash';
import Tooltip from '../../tooltip';
import styles from './styles.css';

class RatingsDistributionChart extends React.Component {
  static propTypes = {
    ratings: PropTypes.shape({
      positive: PropTypes.number,
      negative: PropTypes.number,
      neutral: PropTypes.number,
    }),
    maxRatingCount: PropTypes.number,
  }

  static defaultProps = {
    ratings: {},
    maxRatingCount: 1,
  }

  getRatingsBar = (ratingType) => {
    const { ratings, maxRatingCount } = this.props;
    const ratingCount = ratings[ratingType];
    const ratingPercentage = Math.max(ratingCount * 100 / maxRatingCount, 1);
    const uniqueId = `spark${uuidv4()}`;

    return (
      <>
        <div
          key={uniqueId}
          id={uniqueId}
          className={`${styles.bar} ${styles[ratingType]}`}
          style={{ width: `${ratingPercentage || 1}%` }}
        />
        <Tooltip
          tootipContent={`${_.startCase(ratingType)}: ${ratingCount}`}
          uniqueTargetSelector={`#${uniqueId}`}
        />
      </>
    );
  }

  render() {
    return (
      <div className={styles.ratingsDistribution}>
        {this.getRatingsBar('positive')}
        {this.getRatingsBar('neutral')}
        {this.getRatingsBar('negative')}
      </div>
    );
  }
}

export default RatingsDistributionChart;
